import React from "react"
import Login from "../components/Login"
import { amb } from "../requests/utils"

export default class Auth extends React.Component {
  componentDidMount() {
    // checkUser();
    let datosAuth = window.location.search.replace("?", "")
    if (Boolean(datosAuth)) {
      datosAuth = atob(datosAuth).split("&")
      let id = datosAuth[0].split("=")[1]
      let mail = datosAuth[1].split("=")[1]
      let bDatos = {
        idUsuario: id,
        nombre: mail,
        tkn: "",
      }

      localStorage.setItem(`${amb}_login`, 1)
      sessionStorage.setItem(
        amb + "UD",
        btoa(unescape(encodeURIComponent(JSON.stringify(bDatos))))
      )
      window.location = "/user/"
    }
  }

  render() {
    return (
      <div className="dv_auth_">
        <Login />
      </div>
    )
  }
}
